export default __webpack_public_path__ + "static/media/kitten3M.b89a8544.webp";